import React, { FunctionComponent } from 'react';
import { faLayerGroup } from '@fortawesome/free-solid-svg-icons';
import { BrassIcon, BrassIconProps } from '.';

const BrassIconLayerGroup: FunctionComponent<BrassIconProps> = (
  props: BrassIconProps,
) => <BrassIcon {...props} icon={faLayerGroup} />;

export { BrassIconLayerGroup };
